import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { SvgMatType } from "src/app/constants/icons";
import { EnrollmentBenefitCategoryItem } from "src/app/models/enrollment-category";
import { ListItem } from "src/app/models/listItem";
import { EnrollmentManagerService } from "src/app/services/enrollment-manager.service";

@Component({
    selector: 'mwp-agent-sass-menu',
    templateUrl: './sass-menu.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SassMenuComponent implements OnInit {

    public standardSampleMenu: ListItem[];
    public selectedStandardMenuItem: string;
    public svgType = SvgMatType;
    public benefitCategories: EnrollmentBenefitCategoryItem[];
    public selectedCategoryId: number;
    
    constructor(
        private enrollmentManagerService: EnrollmentManagerService
    ){
        this.standardSampleMenu = [{
            value: 'MEDICAL',
            text: 'MEDICAL'
        },{
            value: 'HEALTH SAVINGS ACCT',
            text: 'HEALTH SAVINGS ACCT'
        },{
            value: 'DENTAL',
            text: 'DENTAL'
        },{
            value: 'DEPENDENT CARE ACCT',
            text: 'DEPENDENT CARE ACCT'
        },{
            value: 'ER PAID LIFE',
            text: 'ER PAID LIFE'
        },{
            value: 'VOLUNTARY LIFE',
            text: 'VOLUNTARY LIFE'
        },{
            value: 'ACCIDENT COVERAGE',
            text: 'ACCIDENT COVERAGE'
        }];

        this.selectedStandardMenuItem = this.standardSampleMenu[0].value;

        this.benefitCategories = [
            {
                id: 111,
                name: "Medical",
                isRequired: true,
                isCompleted: false,
                isWaived: false,
                materialIconName: "warning",
                enrollmentHTML: "",
                isDisabled: false,
            },
            {
                id: 118,
                name: "Flex Spending Accts",
                isRequired: true,
                isCompleted: false,
                isWaived: false,
                materialIconName: "warning",
                enrollmentHTML: "",
                isDisabled: false,
            },
            {
                id: 117,
                name: "Accident Coverage",
                isRequired: false,
                isCompleted: false,
                isWaived: false,
                materialIconName: "",
                enrollmentHTML: "",
                isDisabled: false,
            },
            {
                id: 114,
                name: "Critical Illness Coverage",
                isRequired: false,
                isCompleted: true,
                isWaived: false,
                materialIconName: "",
                enrollmentHTML: "",
                isDisabled: false,
            },
            {
                id: 113,
                name: "Cancer Coverage",
                isRequired: false,
                isCompleted: true,
                isWaived: false,
                materialIconName: "",
                enrollmentHTML: "",
                isDisabled: false,
            },
            {
                id: 115,
                name: "Hospital Indemnity Insurance",
                isRequired: false,
                isCompleted: false,
                isWaived: true,
                materialIconName: "",
                enrollmentHTML: "",
                isDisabled: false,
            },
            {
                id: 112,
                name: "Disability",
                isRequired: false,
                isCompleted: false,
                isWaived: false,
                materialIconName: "",
                enrollmentHTML: "",
                isDisabled: true,
            },
            {
                id: 1718,
                name: "Voya Term Life",
                isRequired: false,
                isCompleted: false,
                isWaived: false,
                materialIconName: "",
                enrollmentHTML: "",
                isDisabled: false,
            },
            {
                id: 1719,
                name: "Trustmark Ul",
                isRequired: false,
                isCompleted: false,
                isWaived: false,
                materialIconName: "",
                enrollmentHTML: "",
                isDisabled: false,
            },
            {
                id: 116,
                name: "Legal Plan & Identity Theft",
                isRequired: false,
                isCompleted: false,
                isWaived: false,
                materialIconName: "",
                enrollmentHTML: "",
                isDisabled: false,
            }
        ];

        this.benefitCategories.push(this.enrollmentManagerService.checkoutItem);

        this.selectedCategoryId = this.benefitCategories[0].id;
    }

    ngOnInit(): void {

    }

    public onStandardMenuSelection(menuItem: string): void {
        this.selectedStandardMenuItem = menuItem;
    }

    public categoryChange(item: EnrollmentBenefitCategoryItem): void {
        this.selectedCategoryId = item.id;
    }
}